<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";

import IframeHost from "../iframe/IFrameHost.vue";
import { useConfigurator } from "../libs/UseConfigurator";
import ConfigurationPanel from "./ConfigurationPanel.vue";
  
const viewer = ref<InstanceType<typeof IframeHost> | null>(null);
const viewerSrc = "http://localhost:5173/";
  
// no await here
const { cfg, productOptions, hasChairs, floorplanList, commitSelection, init, ready } = useConfigurator();
  
onMounted(async () => {
    console.log("DebugPage mounted");
    await nextTick(); // ensure iframe renders
    await init();
    // // send initial scene to viewer
    viewer.value?.update(commitSelection());
});
  
function reloadViewer() {
    viewer.value?.update(commitSelection());
}
function screenshot() {
    viewer.value?.screenshot();
}
function handleImages(map: Record<string, string>) {
    for (const [filename, dataURI] of Object.entries(map)) {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(dataUriToBlob(dataURI));
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
    }
}
function handleCamera(_data: unknown) {
    // console.log("Camera data:", data);
}
  
function dataUriToBlob(dataURI: string) {
    const [meta, base64] = dataURI.split(",");
    const mime = meta.split(":")[1].split(";")[0];
    const bin = atob(base64); const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) { arr[i] = bin.charCodeAt(i); }
    return new Blob([arr], { type: mime });
}
</script>
  
<template>
    <div class="layout">
        <aside class="panel">
            <div
                v-if="!ready"
                class="text-sm text-gray-500"
            >
                Loading…
            </div>
  
            <ConfigurationPanel
                v-if="ready"
                :cfg="cfg"
                :product-options="productOptions"
                :floorplan-options="floorplanList"
                @on-change="() => reloadViewer()"
                @on-screenshot="() => screenshot()"
            />
        </aside>
  
        <IframeHost
            v-if="ready"
            ref="viewer"
            class="viewer"
            :src="viewerSrc"
            @images="(map) => handleImages(map)"
            @camera="(data) => handleCamera(data)"
        />
    </div>
</template>

<style scoped>
.layout {
    display: grid;
    grid-template-rows: 40% 60%;
    height: 100vh;
    overflow: hidden;
}
.panel {
    overflow: auto;
    /* border-bottom: 1px solid #ddd; */
    padding: 8px;
}
.viewer {
    min-height: 0;
    height: 100%;
}
</style>
